import { reactive } from 'vue';
import { useQuery } from 'vue-query';
import { UseQueryOptions } from 'react-query/types';
import QUERY_KEYS from '@/constants/queryKeys';
import useNetwork from '../useNetwork';
import { BalancersType } from '@/services/balancer/subgraph/types';
import { balancerSubgraphService } from '@/services/balancer/subgraph/balancer-subgraph.service';

/**
 * TYPES
 */
type QueryResponse = BalancersType[];

/**
 * Fetch all token lists, should only happen once.
 */
export default function useFlakeCirculatesQuery(
  options: UseQueryOptions<QueryResponse> = {}
) {
  const { networkId } = useNetwork();

  const queryKey = reactive(QUERY_KEYS.Pools.Balancer(networkId));

  const queryFn = async () => {
    return await balancerSubgraphService.balancers.get({});
  };

  const queryOptions = reactive({
    enabled: true,
    ...options
  });

  return useQuery<QueryResponse>(queryKey, queryFn, queryOptions);
}
